const temporarySessionKey = 'temporary_session';

export function setTemporarySession(session: string): void {
  sessionStorage.setItem(temporarySessionKey, session);
}

export function getTemporarySession(): string {
  return sessionStorage.getItem(temporarySessionKey);
}
